export default [{
    name: 'Profile',
    path: `/:locale(${process.env.VUE_APP_AVAILABLE_LOCALES})?/profile`,
    component: () => import('./View.vue'),
}];
